import { observer } from "mobx-react-lite";
import styled from "styled-components";

import { useStores } from "../../stores/useStores";
import { color } from "../../theme/color";
import { SlideOver } from "../ui/SlideOver";
import { MenuLink, MenuList, MenuRow } from "./menuStyles";

/** Slides over the sheet with the setlist's songs, in order. */
export const SetlistMenu = observer(function SetlistMenu({ setlistId, index }: { setlistId: string; index: number }) {
    const { library, navigation, viewer } = useStores();
    const setlist = library.setlist(setlistId);

    if (!setlist) return null;

    const show = (index: number) =>
        navigation.replace({ name: "sheet", chordSheetId: setlist.items[index].chordSheetId, from: { kind: "setlist", setlistId, index } });

    const footer = (
        <>
            <MenuLink onClick={() => navigation.go({ name: "setlists", setlistId })}>Open the setlist</MenuLink>
            <MenuLink onClick={() => navigation.go({ name: "songs" })}>Leave the setlist, go to all songs</MenuLink>
        </>
    );

    return (
        <SlideOver label="setlist" caption="Setlist" title={setlist.name} footer={footer} onClose={() => viewer.toggle("menu")}>
            <MenuList>
                {setlist.items.map((item, i) => {
                    const sheet = library.chordSheet(item.chordSheetId);

                    return (
                        <li key={`${item.chordSheetId}-${i}`}>
                            <MenuRow aria-current={i === index} onClick={() => show(i)}>
                                <Number>{i + 1}</Number>
                                <Text>
                                    <Title>{library.song(sheet?.songId)?.title}</Title>
                                    {sheet?.name && <Version>{sheet.name}</Version>}
                                </Text>
                            </MenuRow>
                        </li>
                    );
                })}
            </MenuList>
        </SlideOver>
    );
});

const Number = styled.span`
    width: 20px;
    font-weight: 600;
    color: ${color.textMuted};
`;

const Text = styled.span`
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
`;

const Title = styled.span`
    font-weight: 600;
`;

const Version = styled.span`
    font-size: 13px;
    color: ${color.textMuted};
`;
